// import React, { useState, useEffect, useCallback } from "react";
// import { useParams } from "react-router-dom";
// import { adminAPI } from "../../services/api";
// import { Plus, Clock, MapPin, Edit2, Trash2 } from "lucide-react";
// import "./Admin.css";

// const SessionManager = () => {
//   const { eventId } = useParams();
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const loadSessions = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await adminAPI.getSessions(eventId);
//       setSessions(res.data);
//     } catch (err) {
//       console.error("Failed to load sessions", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [eventId]);

//   useEffect(() => {
//     loadSessions();
//   }, [loadSessions]);

//   return (
//     <div className="admin-page">
//       <div
//         className="admin-section-header"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "24px",
//         }}
//       >
//         <div>
//           <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
//             Session Management
//           </h1>
//           <p style={{ color: "var(--admin-text-sub)" }}>
//             Manage talks, workshops, and panel discussions
//           </p>
//         </div>
//         <button className="btn-admin btn-admin-primary">
//           <Plus size={18} />
//           <span>Add Session</span>
//         </button>
//       </div>

//       <div className="admin-card">
//         <div className="admin-table-container">
//           <table className="admin-table">
//             <thead>
//               <tr>
//                 <th>Session</th>
//                 <th>Type / Track</th>
//                 <th>Speakers</th>
//                 <th>Time & Location</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td
//                     colSpan="5"
//                     style={{ textAlign: "center", padding: "40px" }}
//                   >
//                     Loading...
//                   </td>
//                 </tr>
//               ) : sessions.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan="5"
//                     style={{ textAlign: "center", padding: "40px" }}
//                   >
//                     No sessions found for this scope.
//                   </td>
//                 </tr>
//               ) : (
//                 sessions.map((session) => (
//                   <tr key={session.id}>
//                     <td>
//                       <div style={{ fontWeight: "600", color: "#0f172a" }}>
//                         {session.title}
//                       </div>
//                       <div style={{ fontSize: "0.75rem", color: "#64748b" }}>
//                         Day {session.day}
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           gap: "4px",
//                         }}
//                       >
//                         <span
//                           className="admin-badge"
//                           style={{
//                             background: "#f1f5f9",
//                             color: "#475569",
//                             alignSelf: "start",
//                           }}
//                         >
//                           {session.session_type}
//                         </span>
//                         <span
//                           style={{
//                             fontSize: "0.7rem",
//                             color: "#94a3b8",
//                             textTransform: "uppercase",
//                           }}
//                         >
//                           {session.track}
//                         </span>
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           gap: "2px",
//                         }}
//                       >
//                         {session.speakers?.map((s) => (
//                           <div key={s.id} style={{ fontSize: "0.8rem" }}>
//                             {s.name}
//                           </div>
//                         ))}
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style={{
//                           display: "flex",
//                           flexDirection: "column",
//                           gap: "4px",
//                           fontSize: "0.8rem",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "4px",
//                           }}
//                         >
//                           <Clock size={14} />
//                           {new Date(session.start_time).toLocaleTimeString([], {
//                             hour: "2-digit",
//                             minute: "2-digit",
//                           })}
//                         </div>
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "4px",
//                           }}
//                         >
//                           <MapPin size={14} />
//                           {session.location}
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div style={{ display: "flex", gap: "12px" }}>
//                         <button className="btn-icon" title="Edit">
//                           <Edit2 size={16} />
//                         </button>
//                         <button className="btn-icon text-danger" title="Delete">
//                           <Trash2 size={16} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SessionManager;

import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { adminAPI, speakersAPI } from "../../services/api";
import { Plus, Clock, MapPin, Edit2, Trash2, X, Save } from "lucide-react";
import "./Admin.css";

const SessionManager = () => {
  const { eventId } = useParams();
  const [sessions, setSessions] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentEvent, setCurrentEvent] = useState(null);
  
  // Modal & Edit State
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  
  // Form State initialized to match Backend Schema
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    session_type: "talk", // Default matches backend Enum
    track: "main",        // Default matches backend Enum
    day: 1,
    start_time: "",
    end_time: "",
    location: "",
    capacity: 100,
    speaker_ids: []
  });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      // Fetch both sessions, speakers, and event details
      const [sessRes, speakRes, eventRes] = await Promise.all([
        adminAPI.getSessions(eventId),
        adminAPI.getSpeakers(),
        adminAPI.getEvent(eventId)
      ]);
      setSessions(sessRes.data);
      setSpeakers(speakRes.data);
      setCurrentEvent(eventRes.data);
    } catch (err) {
      console.error("Failed to load data", err);
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Helper to format backend ISO date to local input value (YYYY-MM-DDTHH:mm)
  const toInputDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const pad = (num) => String(num).padStart(2, '0');
    
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleOpenCreate = () => {
    // Default start/end time for convenience
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(9, 0, 0, 0);
    const end = new Date(tomorrow);
    end.setHours(10, 0, 0, 0);

    setFormData({
      title: "",
      description: "",
      session_type: "talk",
      track: "main",
      day: 1,
      start_time: toInputDate(tomorrow),
      end_time: toInputDate(end),
      location: "",
      capacity: 100,
      speaker_ids: []
    });
    setIsEditing(false);
    setCurrentId(null);
    setShowModal(true);
  };

  const handleOpenEdit = (session) => {
    setFormData({
      title: session.title,
      description: session.description || "",
      session_type: session.session_type,
      track: session.track,
      day: session.day,
      start_time: toInputDate(session.start_time),
      end_time: toInputDate(session.end_time),
      location: session.location || "",
      capacity: session.capacity || 0,
      speaker_ids: session.speakers ? session.speakers.map(s => s.id) : []
    });
    setCurrentId(session.id);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if(!window.confirm("Are you sure you want to delete this session?")) return;
    try {
      await adminAPI.deleteSession(id);
      loadData(); // Refresh list
    } catch (err) {
      console.error("Delete failed", err);
      alert("Could not delete session.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Prepare payload to match SessionCreate schema in backend
      const payload = {
        ...formData,
        event_id: parseInt(eventId), // Ensure ID is integer
        start_time: new Date(formData.start_time).toISOString(),
        end_time: new Date(formData.end_time).toISOString(),
      };

      if (isEditing) {
        await adminAPI.updateSession(currentId, payload);
      } else {
        await adminAPI.createSession(payload);
      }
      setShowModal(false);
      loadData();
    } catch (err) {
      console.error("Save failed", err);
      alert("Failed to save session. Please check your inputs.");
    }
  };

  const handleSpeakerChange = (e) => {
    // Handle multi-select logic
    const options = e.target.options;
    const value = [];
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(parseInt(options[i].value));
      }
    }
    setFormData({ ...formData, speaker_ids: value });
  };

  return (
    <div className="admin-page">
      {/* --- HEADER --- */}
      <div className="admin-section-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
        <div>
          <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>Session Management</h1>
          <p style={{ color: "var(--admin-text-sub)" }}>Manage talks, workshops, and panel discussions</p>
        </div>
        <button className="btn-admin btn-admin-primary" onClick={handleOpenCreate}>
          <Plus size={18} />
          <span>Add Session</span>
        </button>
      </div>

      {/* --- TABLE --- */}
      <div className="admin-card">
        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Session</th>
                <th>Type / Track</th>
                <th>Speakers</th>
                <th>Time & Location</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "40px" }}>Loading...</td></tr>
              ) : sessions.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "40px" }}>No sessions found.</td></tr>
              ) : (
                sessions.map((session) => (
                  <tr key={session.id}>
                    <td>
                      <div style={{ fontWeight: "600", color: "#0f172a" }}>{session.title}</div>
                      <div style={{ fontSize: "0.75rem", color: "#64748b" }}>Day {session.day}</div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <span className="admin-badge" style={{ background: "#f1f5f9", color: "#475569", alignSelf: "start" }}>{session.session_type}</span>
                        <span style={{ fontSize: "0.7rem", color: "#94a3b8", textTransform: "uppercase" }}>{session.track}</span>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                        {session.speakers?.map((s) => (
                          <div key={s.id} style={{ fontSize: "0.8rem" }}>{s.name}</div>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px", fontSize: "0.8rem" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <Clock size={14} />
                          {new Date(session.start_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <MapPin size={14} />
                          {session.location}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "12px" }}>
                        <button className="btn-icon" title="Edit" onClick={() => handleOpenEdit(session)} style={{ border: "none", background: "none", cursor: "pointer" }}>
                          <Edit2 size={16} />
                        </button>
                        <button className="btn-icon text-danger" title="Delete" onClick={() => handleDelete(session.id)} style={{ border: "none", background: "none", cursor: "pointer", color: "#ef4444" }}>
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* --- CREATE/EDIT MODAL --- */}
      {showModal && (
        <div className="modal-overlay" style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", 
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div className="admin-card" style={{ width: "600px", maxHeight: "90vh", overflowY: "auto", padding: "0" }}>
            <div className="card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, background: "white", zIndex: 10 }}>
              <h2 style={{ margin: 0, fontSize: "1.25rem" }}>{isEditing ? "Edit Session" : "New Session"}</h2>
              <button onClick={() => setShowModal(false)} style={{ border: "none", background: "transparent", cursor: "pointer" }}><X size={20} /></button>
            </div>
            
            <form onSubmit={handleSubmit} className="admin-form">
              <div className="form-section">
                <div className="form-group">
                  <label>Title</label>
                  <input 
                    type="text" 
                    required
                    className="form-control"
                    value={formData.title} 
                    onChange={e => setFormData({...formData, title: e.target.value})}
                    placeholder="Enter session title"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Start Time</label>
                    <input 
                      type="datetime-local" 
                      required
                      className="form-control"
                      value={formData.start_time}
                      onChange={e => setFormData({...formData, start_time: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label>End Time</label>
                    <input 
                      type="datetime-local" 
                      required
                      className="form-control"
                      value={formData.end_time}
                      onChange={e => setFormData({...formData, end_time: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Type</label>
                    <select 
                      className="form-control"
                      value={formData.session_type}
                      onChange={e => setFormData({...formData, session_type: e.target.value})}
                    >
                      <option value="keynote">Keynote</option>
                      <option value="talk">Talk</option>
                      <option value="panel">Panel</option>
                      <option value="workshop">Workshop</option>
                      <option value="networking">Networking</option>
                      <option value="break">Break</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Track</label>
                    <select 
                      className="form-control"
                      value={formData.track}
                      onChange={e => setFormData({...formData, track: e.target.value})}
                    >
                      <option value="main">Main</option>
                      <option value="tech">Tech</option>
                      <option value="business">Business</option>
                      <option value="sustainability">Sustainability</option>
                      <option value="innovation">Innovation</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Location</label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={formData.location}
                      onChange={e => setFormData({...formData, location: e.target.value})}
                      placeholder="Room / Hall Name"
                    />
                  </div>
                  {(() => {
                    if (!currentEvent) return null;
                    const start = new Date(currentEvent.start_date).setHours(0,0,0,0);
                    const end = new Date(currentEvent.end_date).setHours(0,0,0,0);
                    const diffDays = Math.round(Math.abs(end - start) / (1000 * 60 * 60 * 24)) + 1;
                    
                    if (diffDays <= 1) return null;

                    return (
                      <div className="form-group">
                        <label>Day (Select 1 to {diffDays})</label>
                        <select 
                          className="form-control"
                          value={formData.day}
                          onChange={e => setFormData({...formData, day: parseInt(e.target.value)})}
                        >
                          {Array.from({ length: diffDays }, (_, i) => (
                            <option key={i+1} value={i+1}>Day {i+1}</option>
                          ))}
                        </select>
                      </div>
                    );
                  })()}
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea 
                    rows="3"
                    className="form-control"
                    value={formData.description}
                    onChange={e => setFormData({...formData, description: e.target.value})}
                    placeholder="Short summary of the session"
                  />
                </div>

                <div className="form-group">
                  <label>Speakers (Hold Ctrl/Cmd to select multiple)</label>
                  <select 
                    multiple
                    className="form-control"
                    value={formData.speaker_ids.map(id => id.toString())}
                    onChange={(e) => {
                      const values = Array.from(e.target.selectedOptions, option => parseInt(option.value));
                      setFormData({...formData, speaker_ids: values});
                    }}
                    style={{ height: "120px" }}
                  >
                    {speakers.map(s => (
                      <option key={s.id} value={s.id}>{s.name}</option>
                    ))}
                  </select>
                  <p className="form-help">Tip: Select speakers from the global list above.</p>
                </div>
              </div>

              <div className="modal-actions">
                <button type="button" className="btn-admin btn-admin-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn-admin btn-admin-primary">
                  <Save size={18} />
                  {isEditing ? "Update Session" : "Create Session"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionManager;